import { socketService } from '@aqx-core/common/socket';

import { IUserNotificationMessage } from '../topics/user';

class UserTopicSubscription {
  public subscribe = (
    traderSubscription: string,
    receiver: (payload: IUserNotificationMessage | undefined) => void
  ) => {
    socketService.topics().user.subscribe({
      traderSubscription,
      receiver: (payload) => receiver(payload)
    });
  };

  public unsubscribe = (
    traderSubscription: string,
    receiver: (payload: IUserNotificationMessage | undefined) => void
  ) => {
    socketService.topics().user.unsubscribe({
      traderSubscription,
      receiver: (payload) => receiver(payload)
    });
  };
}

export const userTopicSubscription = new UserTopicSubscription();
